import api from '@/http/api';
import handleMetaData from './dataProcess';
import axios from 'axios';

async function safeApiRequest(apiFunc, fallback = []) {
  try {
    return await apiFunc();
  } catch (err) {
    console.error('API request failed:', err?.response?.data || err.message);
    return { data: fallback };
  }
}
export default async function epicDataQuery(patientId) {
  const patientRes = await safeApiRequest(
    () =>
      api.r4EpicInfoGet({
        endpoint: `Patient/${patientId}`,
      }),
    { data: {} },
  );
  // const medicationOrderRes = await api.DSTU2EpicInfoGet({
  //   endpoint: `MedicationOrder`,
  //   params: {
  //     patient: patientRes.data.id,
  //   },
  // });
  // const medicationOrderUrlList = [];
  // for (const order of medicationOrderRes.data.entry) {
  //   if (order.fullUrl && order.fullUrl.includes('https')) {
  //     medicationOrderUrlList.push(order.resource.medicationReference.reference);
  //   }
  // }
  // let medicationOrderRequests = [];
  // for (const url of medicationOrderUrlList) {
  //   medicationOrderRequests.push(axios.get(url));
  // }
  // const medicationResponses = await Promise.all(medicationOrderRequests);
  const procedureRes = await safeApiRequest(() =>
    api.r4EpicInfoGet({
      endpoint: `Procedure`,
      params: {
        patient: patientRes.data.id,
      },
    }),
  );
  const DiagnosticReportRes = await safeApiRequest(() =>
    api.r4EpicInfoGet({
      endpoint: `DiagnosticReport`,
      params: {
        patient: patientRes.data.id,
      },
    }),
  );

  const DocumentReferenceClinicalNotesRes = await safeApiRequest(() =>
    api.r4EpicInfoGet({
      endpoint: `DocumentReference`,
      params: {
        patient: patientRes.data.id,
        category: 'clinical-note',
      },
    }),
  );
  // 保存DiagnosticReport中可能出现的binary数据
  let binaryUrlList = [];
  for (const item of DiagnosticReportRes.data.entry) {
    if (item.fullUrl && item.fullUrl.includes('https')) {
      const list = (item.resource.presentedForm || []).map(
        (subItem) => subItem.url,
      );
      binaryUrlList = [...binaryUrlList, ...list];
    }
  }
  // console.log(binaryUrlList);
  // 保存DocumentReferenceClinicalNotes中可能出现的binary数据
  for (const item of DocumentReferenceClinicalNotesRes.data.entry) {
    if (item.fullUrl && item.fullUrl.includes('https')) {
      const list = (item.resource.content || []).map(
        (subItem) => subItem.attachment.url,
      );
      binaryUrlList = [...binaryUrlList, ...list];
    }
  }
  // console.log(binaryUrlList);
  // let binaryRequests = [];
  // for (const url of binaryUrlList) {
  //   binaryRequests.push(
  //     api.r4EpicInfoGet({
  //       endpoint: url,
  //     })
  //   );
  // }
  // let binaryResponses = [];
  // binaryResponses = await Promise.all(binaryRequests).catch((err) => {
  //   // Promise.all 中有一个或多个 Promise 失败时执行
  //   console.error("One or more promises failed:", err);
  // });
  // console.log(binaryResponses);
  // 新api
  const MedicationRequestRes = await safeApiRequest(() =>
    api.r4EpicInfoGet({
      endpoint: `MedicationRequest`,
      params: {
        patient: patientRes.data.id,
      },
    }),
  );

  const AllergyIntoleranceRes = await safeApiRequest(() =>
    api.r4EpicInfoGet({
      endpoint: `AllergyIntolerance`,
      params: {
        patient: patientRes.data.id,
      },
    }),
  );

  const CarePlanEncounterLevelRes = await safeApiRequest(() =>
    api.r4EpicInfoGet({
      endpoint: `CarePlan`,
      params: {
        patient: patientRes.data.id,
        category: '734163000',
      },
    }),
  );

  const CarePlanLongitudinalRes = await safeApiRequest(() =>
    api.r4EpicInfoGet({
      endpoint: `CarePlan`,
      params: {
        patient: patientRes.data.id,
        category: '38717003',
      },
    }),
  );
  // const ConditionCarePlanProblemRes = await api.r4EpicInfoGet({
  //   endpoint: `Condition`,
  //   params: {
  //     _id: patientRes.data.id,
  //   },
  // });
  // console.log(ConditionCarePlanProblemRes.data);
  const ConditionHealthConcernRes = await safeApiRequest(() =>
    api.r4EpicInfoGet({
      endpoint: `Condition`,
      params: {
        patient: patientRes.data.id,
        category: 'health-concern',
      },
    }),
  );

  const ConditionProblemsRes = await safeApiRequest(() =>
    api.r4EpicInfoGet({
      endpoint: `Condition`,
      params: {
        patient: patientRes.data.id,
        category: 'problem-list-item',
      },
    }),
  );
  const DeviceRes = await safeApiRequest(() =>
    api.r4EpicInfoGet({
      endpoint: `Device`,
      params: {
        patient: patientRes.data.id,
      },
    }),
  );

  const EncounterRes = await safeApiRequest(() =>
    api.r4EpicInfoGet({
      endpoint: `Encounter`,
      params: {
        patient: patientRes.data.id,
      },
    }),
  );
  // 从encounter中获取具体的location信息
  let locationUrlList = [];
  for (const encounter of EncounterRes.data.entry) {
    if (encounter.fullUrl && encounter.fullUrl.includes('https')) {
      const list = (encounter.resource.location || []).map((subItem) => {
        return {
          reference: subItem.location.reference,
          encounterId: encounter.resource.id,
        };
      });
      locationUrlList = [...locationUrlList, ...list];
    }
  }
  const locationRequests = locationUrlList.map(({ reference }) =>
    safeApiRequest(() => api.r4EpicInfoGet({ endpoint: reference }), {
      data: {},
    }),
  );
  const locationResponses = await Promise.all(locationRequests);
  const GoalRes = await safeApiRequest(() =>
    api.r4EpicInfoGet({
      endpoint: `Goal`,
      params: {
        patient: patientRes.data.id,
      },
    }),
  );

  const ImmunizationRes = await safeApiRequest(() =>
    api.r4EpicInfoGet({
      endpoint: `Immunization`,
      params: {
        patient: patientRes.data.id,
      },
    }),
  );
  // const LocationRes = await api.r4EpicInfoGet({
  //   endpoint: `Location`,
  //   params: {
  //     _id: patientRes.data.id,
  //   },
  // });
  // console.log(LocationRes.data);
  // const observationLaboratoryRes = await api.r4EpicInfoGet({
  //   endpoint: `Observation`,
  //   params: {
  //     patient: patientRes.data.id,
  //     category: "laboratory",
  //   },
  // });
  // const observationSocialHistoryRes = await api.r4EpicInfoGet({
  //   endpoint: `Observation`,
  //   params: {
  //     patient: patientRes.data.id,
  //     category: "social-history",
  //   },
  // });
  // const observationVitalsRes = await api.r4EpicInfoGet({
  //   endpoint: `Observation`,
  //   params: {
  //     patient: patientRes.data.id,
  //     category: "vital-signs",
  //   },
  // });
  // const OrganizationRes = await api.r4EpicInfoGet({
  //   endpoint: `Organization`,
  //   params: {
  //     _id: patientRes.data.id,
  //   },
  // });
  // console.log(OrganizationRes.data);
  const patientData = {
    patient: patientRes.data,
    // observationLaboratory: observationLaboratoryRes.data,
    // medicationOrder: medicationOrderRes.data,
    // medication: medicationResponses.map((item) => item.data),
    procedure: procedureRes.data,
    diagnostic: DiagnosticReportRes.data,
    // binary: binaryResponses.map((item) => item.data),
    binary: [],
    MedicationRequest: MedicationRequestRes.data,
    AllergyIntolerance: AllergyIntoleranceRes.data,
    CarePlanEncounterLevel: CarePlanEncounterLevelRes.data,
    CarePlanLongitudinal: CarePlanLongitudinalRes.data,
    ConditionHealthConcern: ConditionHealthConcernRes.data,
    ConditionProblems: ConditionProblemsRes.data,
    Device: DeviceRes.data,
    DocumentReferenceClinicalNotes: DocumentReferenceClinicalNotesRes.data,
    Encounter: EncounterRes.data,
    location: locationResponses.map((item) => item.data),
    locationUrlList,
    Goal: GoalRes.data,
    Immunization: ImmunizationRes.data,
    // observationSocialHistory: observationSocialHistoryRes.data,
    // observationVitals: observationVitalsRes.data,
  };
  // const result = handleMetaData(patientData);
  return Promise.resolve(patientData);
}
